/**
 * The product's name, in one place.
 *
 * Every screen that shows the platform's own name imports it from here — the sidebar, the
 * sign-in pages, the landing page, e-mail placeholders, the backup filename. Renaming the
 * product is this file plus `backend/brand.py`; nothing else should hard-code it.
 *
 *   import { BRAND_NAME } from '../brand';
 *
 * A tenant's own name always wins where one exists (Sidebar, ChangePasswordPage): learners
 * on an organisation's portal see their organisation, not the platform behind it.
 */
export const BRAND_NAME = 'MyLMS';

/** The line under the name in the sidebar and on the sign-in pages. */
export const BRAND_TAGLINE = 'Learning Management Platform';

/** Lower-case, safe for filenames and URLs — e.g. `mylms-backup-20261023-1830.zip`. */
export const BRAND_SLUG = 'mylms';

/** The copyright line in the landing-page footer. */
export const BRAND_COPYRIGHT = `© ${new Date().getFullYear()} ${BRAND_NAME}. All rights reserved.`;

const brand = { BRAND_NAME, BRAND_TAGLINE, BRAND_SLUG, BRAND_COPYRIGHT };
export default brand;
